<template>
  <main class="common-container">
    <section class="explanation-container center">
      <img :src="explainImg1" alt="" />
      <ul class="color-circle">
        <li class="color-circle__item">
          <p>{{ $t("lineExp.descText1") }}</p>
        </li>
        <li class="color-circle__item">
          <p>{{ $t("lineExp.descText2") }}</p>
          <br />
          <br />
          <p>{{ $t("lineExp.descText3") }}</p>
          <p>{{ $t("lineExp.descText4") }}</p>
          <p>{{ $t("lineExp.descText5") }}</p>
        </li>
      </ul>
    </section>
  </main>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from "vue";
import { useResolutionStore } from "@/store/useResolution";
import lineImg from "@/assets/images/pages/explanation/line/line_explanation.png";
import lineMImg from "@/assets/images/pages/explanation/line/line_explanation-m.png";

const resolutionStore = useResolutionStore();
const isMobile = computed(() => resolutionStore.isMobile);
// isMobile 값이 변경될 때 자동으로 업데이트됨
const explainImg1 = computed(() => (isMobile.value ? lineMImg : lineImg));
// const explainImg2 = computed(() =>
//   isMobile.value ? coinlistMImg2 : coinlistImg2
// );
// const explainImg3 = computed(() =>
//   isMobile.value ? coinlistMImg3 : coinlistImg3
// );

const updateWindowSize = () => {
  resolutionStore.setSize({ width: window.innerWidth });
};

onMounted(() => {
  window.addEventListener("resize", updateWindowSize);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWindowSize);
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/explanation/common_explanation.scss";
</style>
